import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const TrackingSection = () => {
  return (
    <section
          id='seguimiento'
          className='py-5 bg-gradient-primary'
          style={{ color: "#182848" }}
        >
          <Container>
            <Row className='align-items-center'>
              <Col lg={6} className='mb-5 mb-lg-0'>
                <Player
                  autoplay
                  loop
                  src={trackingAnimation}
                  style={{ height: "100%", width: "100%" }}
                />
              </Col>

              <Col lg={6}>
                <h2 className='display-5 fw-bold mb-4'>
                  Rastrea tus <span className='text-warning'>envíos</span> en
                  tiempo real
                </h2>
                <p className='lead mb-5 opacity-75'>
                  Con nuestro sistema de seguimiento, sabrás exactamente dónde
                  está tu paquete en cada momento.
                </p>

                <div className='d-flex flex-column gap-4'>
                  {[
                    {
                      title: "Recibido en Miami",
                      description:
                        "Te notificamos cuando tu paquete llega a nuestro almacén.",
                    },
                    {
                      title: "En tránsito",
                      description:
                        "Seguimiento durante todo el viaje a Honduras.",
                    },
                    {
                      title: "Entrega programada",
                      description:
                        "Coordinamos la entrega final a tu domicilio.",
                    },
                  ].map(({ title, description }, idx) => (
                    <div key={idx} className='d-flex align-items-start gap-3'>
                      <div
                        className='rounded-circle d-flex align-items-center justify-content-center'
                        style={{
                          width: 44,
                          height: 44,
                          flexShrink: 0,
                          fontWeight: "700",
                          fontSize: "1.25rem",
                          color: "white",
                          backgroundColor: "#182848",
                          userSelect: "none",
                          boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                        }}
                        aria-label={`Paso ${idx + 1}`}
                      >
                        {idx + 1}
                      </div>
                      <div>
                        <h5 className='mb-1 fw-semibold'>{title}</h5>
                        <p className='mb-0 opacity-75'>{description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Botón para redirigir */}
                <div className='mt-4'>
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href='https://mbox-hn.com/seguimiento'
                    className='btn btn-primary'
                  >
                    Rastrear Mi Paquete
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
  );
};

export default TrackingSection;
